import { useEffect } from "react";
import { API_ENDPOINTS } from "../config/api";
import { getAuthToken } from "../utils/auth";

const HEARTBEAT_INTERVAL = 2 * 60 * 1000; // 2 minutes

export default function UserHeartbeat() {
    useEffect(() => {
        const sendHeartbeat = () => {
            const token = getAuthToken();
            if (!token) return;
            fetch(API_ENDPOINTS.USER.HEARTBEAT, {
                method: "POST",
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
                credentials: "include",
            }).catch(() => { /* best-effort, ignore errors */ });
        };

        sendHeartbeat();
        const interval = setInterval(sendHeartbeat, HEARTBEAT_INTERVAL);
        return () => clearInterval(interval);
    }, []);

    return null;
}
